import { Link } from "react-router-dom";

const FINE_ART_CATEGORY_ID = 1;

const getFineArtHelperText = artworkId => (
  <>
    This field can only be changed by editing the artwork record{" "}
    {artworkId ? (
      <Link className="underline" to={`/artworks/${artworkId}/details`}>
        here
      </Link>
    ) : (
      "here"
    )}
    .
  </>
);

const getArtworkCaptionInput = ({ artworkId, categoryId } = {}) => {
  const isFineArt = categoryId === FINE_ART_CATEGORY_ID;

  return {
    label: "Artwork Caption",
    name: "description",
    rows: 3,
    type: "textarea",
    disabled: isFineArt,
    helperText: isFineArt ? getFineArtHelperText(artworkId) : "",
    submitOnBlur: !isFineArt,
  };
};

export { getArtworkCaptionInput };
